import React from 'react';
import PropTypes from 'prop-types';
import { DragSource as dragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

const source = {
  beginDrag(props) {
    const { childNode, onDrag } = props;
    const draggableNodes = onDrag(childNode);
    return { selectedNodes: draggableNodes };
  },
  endDrag(props, monitor) {
    const { onDrop, handleInvalidDrop } = props;
    if (!monitor.didDrop()) {
      handleInvalidDrop();
      return;
    }
    onDrop(monitor.getItem().selectedNodes);
  },
};

const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
  connectDragPreview: connect.dragPreview(),
});

const DraggableGeomapNode = ({
  isMultipleItemSelected,
  childNode,
  handleNodeSelection,
  toggleParentNode,
  connectDragSource,
  toggleIcon,
  selectedClass,
  connectDragPreview,
}) => {
  if (isMultipleItemSelected) {
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true,
    });
  }
  const renderNode = (
    <div
      className={`category category-question ${selectedClass}`}
      title={childNode.n}
      role="button"
      tabIndex="0"
    >
      {childNode.s &&
        <span
          onClick={() => toggleParentNode(childNode)}
          className="toggle-icon"
        >{ toggleIcon }</span>}
      <label
        htmlFor="drag-icon"
        className="node-label"
        onClick={e => handleNodeSelection(e, childNode)}
      >{ childNode.n }</label>
      <span id="drag-icon" className="draagable-icon" />
    </div>
  );

  return connectDragSource(
    <li style={{ opacity: '1' }}>{renderNode} </li>
  );
};

DraggableGeomapNode.propTypes = {
  childNode: PropTypes.shape({
    node: PropTypes.number,
    title: PropTypes.string,
  }),
  handleNodeSelection: PropTypes.func,
};

export default dragSource('CATEGORY', source, collect)(DraggableGeomapNode);
